import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  MaxLengthValidator,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';
import { NgbAccordion } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from "../../../_services/alert.service";
import { environment } from "../../../../environments/environment";
import { ApiHttpService } from "../../../_services/api-http.service";
import {
  ColDef,
  FilterChangedEvent,
  FilterModifiedEvent,
  FilterOpenedEvent,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
  PaginationChangedEvent,
  RowClickedEvent,
} from 'ag-grid-community';
const { API_URL } = environment;
@Component({
  selector: 'app-ira-report',
  templateUrl: './ira-report.component.html',
  styleUrls: ['./ira-report.component.scss']
})
export class IraReportComponent implements OnInit {
  orvreport: FormGroup;
  form: FormGroup;
  Resultdata: any;
  merchantId:any;
  pageSize: number = 10;
  private filterObj: any = {};
  SingleRow: any;
  currentPage: number = 0;
  collectionSize: number = 0;
  merchantdis: boolean = true;
  filedis: boolean = true;
  selectedFile:any;
  loading: boolean = false;
  flagcheck:boolean=true;
  private specialKeys: Array<string> = [
    "Backspace",
    "Tab",
    "End",
    "Home",
    "-",
    "ArrowLeft",
    "ArrowRight",
    "Del",
    "Delete"
  ];
  @ViewChild('acc') private acc: NgbAccordion;
  private gridApi!: GridApi;
  // public rowData: any[];
  public rowData: any[] = [
    // Add more rows here as needed...
  ];
  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 150,
    filter: false,
    resizable: true
  };
  public columnDefs: ColDef[] = [
    { field: 'id', headerName: 'ID', hide: true },
    { field: 'merchantName', tooltipField: 'sp_id', headerName: 'Merchant Name'},
    { field: 'merchantId', tooltipField: 'sp_id', headerName: 'Merchant ID'},
    { field: "fileName", tooltipField: 'sp_id', headerName: 'File Name' },
    { field: 'createDate', tooltipField: 'sp_id', headerName: 'Create Date'},
    { field: "updateDate", tooltipField: 'sp_id', headerName: 'Update Date' },
  ];
  tableSelectedColumn: ColDef[] = [...this.columnDefs];
  constructor(private  formBuilder: FormBuilder, private apiHttpService: ApiHttpService,private alertService: AlertService, ) {
    this.orvreport = formBuilder.group({
      merchantId: ["", Validators.required],
      fileupload:["",Validators.required],
    })
  }
    ngOnInit(): void {
      let merchantdata = { "name": "" }
    this.apiHttpService
      .post(`${API_URL}/GetMerchant`, merchantdata)
      .subscribe((res) => {
        this.Resultdata = res
      });
    }
    disableUploadbtn:boolean=false;
    ondata(data:any){
      debugger
      this.loading = false
      return this.apiHttpService
      .post(
        `${API_URL}/docs/findDocs/${data}/IRA?pageSize=10&page=1`, null
      )
      .subscribe((data) => {
        this.collectionSize = data.totalElements;    
        if(this.collectionSize>0){           
          this.disableUploadbtn=true
          } else{
            this.disableUploadbtn=false
          } 
        this.rowData = (data.content?.data|| Array.isArray(data.content) ? data.content : []).map((d: any) => {
           return {
            ...d,
          }
        })
      });
    }
    onMerchantSearch(event:Event){
      this.merchantdis=true;
      if(event){
        this.ondata(event);
      }else{
        this.reloadonGridReady();
      }
    }
    file:any;
    onFileSelected(event: Event): void {
      this.filedis=true;
      const inputElement = event.target as HTMLInputElement;
      if (inputElement.files && inputElement.files.length > 0) {
        this.selectedFile = inputElement.files[0];
      }

      if( this.selectedFile.type != "application/pdf" ){
        this.flagcheck=false
        this.filedis=false;
      }else{
        this.flagcheck=true
        this.filedis=true;
      }
    }
    onSubmit(formvalue: any): void {
     if(formvalue.merchantId&&formvalue.fileupload){
      this.filedis=true;
          this.merchantdis=true;
      const formData = new FormData();
      formData.append('imageFile', this.selectedFile);
      formData.append('merchantId',  this.merchantId || formvalue.merchantId,);
      formData.append('type',"IRA" );
      this.apiHttpService
          .post(
           `${API_URL}/docs/upload`,
            //`${API_URL}/docs/upload`,
            formData
          ).subscribe((data) => {
            document?.getElementById('loading')?.classList.remove("spinner-border")
            document?.getElementById('loading')?.classList.remove("spinner-border-sm");
            if (!data?.null) {
              if(data.responseCode=="1111"){
              this.alertService.successAlert( "File Upload Successfully!");
             this.reloadonGridReady();
             this.orvreport.reset();
            }else if(data.responseCode=="0000"){
                this.alertService.successAlert( "File Upload  Updated Successfully!");
                this.reloadonGridReady();
                this.orvreport.reset();
              }
              else{
                this.alertService.errorAlert({text:"File upload fail.!"})
              }
            }
          }, (error) => {
            console.log("Error------>", error);
          });
        }
        else{
         if(! formvalue.merchantId){
this.merchantdis=false;
         }
         if(!  formvalue.fileupload){
          this.filedis=false;
         }
         if(! this.flagcheck){
          this.filedis=false;
         }
        }
    }
    onGridReady(params: GridReadyEvent<any>) {
      this.filedis=true;
      this.merchantdis=true;
      debugger
      this.loading = false
      return this.apiHttpService
      .post(
        `${API_URL}/docs/fetchDocs/${this.pageSize}/${this.currentPage}?type=IRA`, null
      )
      .subscribe((data) => {
        this.collectionSize = data.totalElements;
        this.rowData = (data.content?.data|| Array.isArray(data.content) ? data.content : []).map((d: any) => {
           return {
            ...d,
          }
        })
      });
    }
    reloadonGridReady(){
      
        this.disableUploadbtn=false
    
      this.filedis=true;
      this.merchantdis=true;
      debugger
      this.loading = false
      return this.apiHttpService
      .post(
        `${API_URL}/docs/fetchDocs/${this.pageSize}/${this.currentPage}?type=IRA`, null
      )
      .subscribe((data) => {
        this.collectionSize = data.totalElements;
        this.rowData = (data.content?.data|| Array.isArray(data.content) ? data.content : []).map((d: any) => {
          return {
            ...d,
          }
        })
      });
    }
    onFilterOpened(param: FilterOpenedEvent | any) {
      console.log("onFilterOpened----->", param);
    }
    onFilterModified(param: FilterModifiedEvent | any) {
      debugger
      const temp = param?.filterInstance;
      this.filterObj[param?.column?.colId] = temp;
    }
    onRowDoubleClicked(param: RowClickedEvent | any) {
      debugger
      let coldata=param.data;
     let merchant=coldata.merchantId;
      this.apiHttpService
      .post(
        `${API_URL}/docs/download/${coldata.merchantId}/IRA`, null
        )
      .subscribe((data) => (
       this.downloadPdf(data,merchant)
      ));
      param.node.setExpanded(!param.node.expanded);
    }
    downloadPdf(data:any,merchantdata:any) {
      const linkSource =
      'data:application/octet-stream;base64,' +data.text;
      const downloadLink = document.createElement('a');
      const fileName = merchantdata+'IRA.pdf';
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    }
    async onRowClicked(param: RowClickedEvent | any) {
      this.SingleRow = param.data
    }
    onPageSizeChanges($event: Event) {
      this.apiHttpService
        .post(
          `${API_URL}/docs/fetchDocs/${this.pageSize}/${this.currentPage}?type=IRA`, null
          )
        .subscribe((data) => (
          this.rowData = data.content?.data || Array.isArray(data.content) ? data.content: [],
          this.collectionSize = data.totalElements,
          this.gridApi.applyTransaction({ add: this.rowData })
        ));
    }
    onPaginationChange(param: PaginationChangedEvent | any) {
      debugger
      //this.gridApi.paginationGoToPage(param - 1)
      return this.apiHttpService
      .post(
        `${API_URL}/docs/fetchDocs/${this.pageSize}/${param}?type=IRA`, null
      )
      .subscribe((data) => {
        this.collectionSize = data.totalElements;
        this.rowData = (data.content?.data|| Array.isArray(data.content) ? data.content : []).map((d: any) => {
          return {
            ...d,
          }
        })
      });
    }
  }